import React from 'react';
import { Zap, ArrowRight, MoreHorizontal, Link2 } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
export interface HookCardProps {
  id: string;
  hookText: string;
  sourceIdea: string;
  category: string;
  tone: string;
  dateGenerated: string;
  onCreateConcept?: (id: string) => void;
}
export function HookCard({
  id,
  hookText,
  sourceIdea,
  category,
  tone,
  dateGenerated,
  onCreateConcept
}: HookCardProps) {
  return <Card className="group overflow-hidden border-gray-200 hover:shadow-lg transition-all duration-300 bg-white h-full flex flex-col" data-id="element-471">
      <CardContent className="p-5 flex-1 flex flex-col" data-id="element-472">
        {/* Header */}
        <div className="flex justify-between items-start gap-2 mb-3" data-id="element-473">
          <div className="h-10 w-10 rounded-lg bg-amber-500/10 flex items-center justify-center flex-shrink-0" data-id="element-474">
            <Zap className="h-5 w-5 text-amber-600" data-id="element-475" />
          </div>
          <Button variant="ghost" size="icon" className="h-6 w-6 -mr-2 text-gray-400 hover:text-gray-600" data-id="element-476">
            <MoreHorizontal className="h-4 w-4" data-id="element-477" />
          </Button>
        </div>

        {/* Category */}
        <Badge variant="secondary" className="bg-amber-500 text-white hover:bg-amber-600 border-none font-medium px-2.5 w-fit mb-3" data-id="element-478">
          {category}
        </Badge>

        {/* Hook Text */}
        <div className="bg-gray-50 rounded-lg p-4 mb-4 flex-1" data-id="element-479">
          <p className="text-sm font-medium text-gray-900 leading-relaxed" data-id="element-480">
            "{hookText}"
          </p>
        </div>

        {/* Source Idea Link */}
        <div className="flex items-center gap-2 mb-3 text-xs text-gray-500" data-id="element-481">
          <Link2 className="h-3.5 w-3.5" data-id="element-482" />
          <span className="truncate" data-id="element-483">From: {sourceIdea}</span>
        </div>

        {/* Tone Badge */}
        <div className="mb-4" data-id="element-484">
          <Badge variant="outline" className="text-xs font-normal text-gray-600 border-gray-200 bg-gray-50" data-id="element-485">
            {tone}
          </Badge>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between pt-4 border-t border-gray-100 mt-auto" data-id="element-486">
          <span className="text-xs text-gray-500" data-id="element-487">{dateGenerated}</span>
          <Button size="sm" onClick={() => onCreateConcept?.(id)} className="bg-[#139191] hover:bg-[#139191]/90 text-white gap-2 text-xs" data-id="element-488">
            Create Concept
            <ArrowRight className="h-3.5 w-3.5" data-id="element-489" />
          </Button>
        </div>
      </CardContent>
    </Card>;
}